import PACAA020 from '../../pages/Auth/PACAA020';
import PACAB010 from '../../pages/Auth/PACAB010';
import PABAA010 from '../../pages/CommonSearch';
import PAAAA010 from '../../pages/Home';
import Register from '../../pages/Register';

import PAGAA010 from '../../pages/DentalPlus/PAGAA010';
import PAGAA020 from '../../pages/DentalPlus/PAGAA020';
import PAGAB010 from '../../pages/DentalPlus/PAGAB010';
import PAGAB020 from '../../pages/DentalPlus/PAGAB020';
import PAGAI010 from '../../pages/DentalPlus/PAGAI010';
import PAGAJ010 from '../../pages/DentalPlus/PAGAJ010';

import PAEAA010 from '../../pages/Recruit/PAEAA010';
import PAEAA011 from '../../pages/Recruit/PAEAA011';
import PAEAA012 from '../../pages/Recruit/PAEAA012';
import PAEAA013 from '../../pages/Recruit/PAEAA013';
import PAEAA014 from '../../pages/Recruit/PAEAA014';
import PAEAA015 from '../../pages/Recruit/PAEAA015';
import PAEAA016 from '../../pages/Recruit/PAEAA016';
import PAEAA017 from '../../pages/Recruit/PAEAA017';
import PAEAA070 from '../../pages/Recruit/PAEAA070';

import PAFAA010 from '../../pages/Resume/PAFAA010';
import PAFAA011 from '../../pages/Resume/PAFAA011';
import PAFAA012 from '../../pages/Resume/PAFAA012';
import PAFAA013 from '../../pages/Resume/PAFAA013';
import PAFAA014 from '../../pages/Resume/PAFAA014';
import PAFAA015 from '../../pages/Resume/PAFAA015';
import PAFAA016 from '../../pages/Resume/PAFAA016';
import PAFAA060 from '../../pages/Resume/PAFAA060';

import PAHAA010 from '../../pages/CustomerServiceCenter/PAHAA010';
import PAHAB010 from '../../pages/CustomerServiceCenter/PAHAB010';
import PAHAC010 from '../../pages/CustomerServiceCenter/PAHAC010';
import PAHAD010 from '../../pages/CustomerServiceCenter/PAHAD010';
import PAHAE010 from '../../pages/CustomerServiceCenter/PAHAE010';
import PAHAF010 from '../../pages/CustomerServiceCenter/PAHAF010';
import PAHAF020 from '../../pages/CustomerServiceCenter/PAHAF020';
import PAHAG010 from '../../pages/CustomerServiceCenter/PAHAG010';
import PAHAH010 from '../../pages/CustomerServiceCenter/PAHAH010';

import PAGAH010 from '../../pages/DentalPlus/PAGAH010';
import PAGAC010 from '../../pages/Magazine/PAGAC010';
import PAGAC020 from '../../pages/Magazine/PAGAC020';
import AuthRedirect from '../../shared/components/AuthRedirect';
import KcpCertRedirect from '../../shared/components/KcpCertRedirect';
import PaymentCancel from '../../shared/components/PaymentCancel';
import withLogged from '../../shared/hocs/WithLogged';
import withNotLogged from '../../shared/hocs/WithNotLogged';

const routersMain = [
    { path: '/', element: PAAAA010 },
    { path: '/paca020', element: PACAA020 },

    { path: '/paeaa010', element: PAEAA010 },
    { path: '/paeaa070-:id', element: PAEAA070 },
    { path: '/pafaa010', element: PAFAA010 },
    { path: '/pafaa011', element: PAFAA011 },
    { path: '/pafaa012', element: PAFAA012 },
    { path: '/pafaa013', element: PAFAA013 },
    { path: '/pafaa014', element: PAFAA014 },
    { path: '/pafaa015', element: PAFAA015 },
    { path: '/pafaa016', element: PAFAA016 },
    { path: '/pafaa060-:id', element: withNotLogged(PAFAA060) },
    { path: '/pabaa010', element: PABAA010 },
    { path: '/pagaa010', element: PAGAA010 },
    { path: '/pagaa020-:id', element: PAGAA020 },
    { path: '/pagab010', element: PAGAB010 },
    { path: '/pagab020-:id', element: PAGAB020 },
    { path: '/pagai010', element: PAGAI010 },
    { path: '/pagah010', element: PAGAH010 },
    { path: '/pagaj010', element: PAGAJ010 },

    { path: '/pahaa010', element: PAHAA010 },
    { path: '/pahab010', element: PAHAB010 },
    { path: '/pahac010', element: PAHAC010 },
    { path: '/pahad010', element: PAHAD010 },
    { path: '/pahae010', element: PAHAE010 },
    { path: '/pahaf010', element: PAHAF010 },
    { path: '/pahaf020-:id', element: PAHAF020 },
    { path: '/pahag010', element: PAHAG010 },
    { path: '/pahah010', element: PAHAH010 },
    { path: '/padaa010', element: withLogged(Register) },
    { path: '/paeaa011', element: PAEAA011 },
    { path: '/paeaa012', element: PAEAA012 },
    { path: '/paeaa013', element: PAEAA013 },
    { path: '/paeaa014', element: PAEAA014 },
    { path: '/paeaa015', element: PAEAA015 },
    { path: '/paeaa016', element: PAEAA016 },
    { path: '/paeaa017', element: PAEAA017 },
    { path: '/pagac010', element: PAGAC010 },
    { path: '/pagac020', element: PAGAC020 },
    { path: '/pacab010', element: withLogged(PACAB010) },
    { path: '/payment-cancel', element: PaymentCancel },
    { path: '/auth-redirect', element: AuthRedirect },
    { path: '/kcp-cert/result', element: KcpCertRedirect },
];

export default routersMain;
